/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { ResponsiveBullet } from '@nivo/bullet';
import { genDataBullet } from '../../utils/formatCharts/handleData';
import { bulletColorSelector } from '../../utils/formatCharts/handleColor';
import customTooltip from '../../utils/chartTools/handleCustomTooltip';
import KpiStatus from '../../utils/chartTools/KpiStatus';

const emptyObj = {};

const Bullet = ({
  data, styleConfig, globalConfig = emptyObj,
}) => {
  const [chartData, setChartData] = useState({ ready: false });

  useEffect(() => {
    setChartData(genDataBullet(data, styleConfig));
  }, [
    data,
    styleConfig.DataFormat,
    styleConfig.DataPercentFormat,
    styleConfig.GroupModeControl,
    ...styleConfig.CustomSortControl.kpiCategories,
    styleConfig.SortValuesControl,
    styleConfig.MetricTypeControl,
  ]);

  const createTooltip = (val) => customTooltip(val, 'bullet', styleConfig);

  return chartData.ready ? (
    <KpiStatus
      conditions={([
        [
          'NeedsTwoNumericValue',
          !chartData?.isBullet,
        ],
        [
          'HasNegativeValues',
          chartData.hasNegative,
        ],
      ])}
    >
      <ResponsiveBullet
        data={chartData.data}
        /* GENERAL */
        reverse={!!styleConfig.ReverseControl.checked}
        layout={styleConfig.LayoutControl}
        spacing={styleConfig.BarsPaddingControl}
        measureSize={styleConfig.MeasureSizeControl}
        markerSize={styleConfig.MarkersSizeControl}
        margin={styleConfig.Margin}
        minValue={
          styleConfig.MinValueControl.checked ? 'auto' : styleConfig.MinValueControl.value
        }
        maxValue={
          styleConfig.MaxValueControl.checked ? 'auto' : styleConfig.MaxValueControl.value
        }
        /* STYLE */
        rangeBorderWidth={styleConfig.ExtBorderWidthControl}
        rangeBorderColor={styleConfig.ExtBorderColorControl}
        measureBorderWidth={styleConfig.IntBorderWidthControl}
        measureBorderColor={styleConfig.IntBorderColorControl}
        measureColors={[styleConfig.MetricColorControl]}
        markerColors={[styleConfig.MetricColorControl]}
        rangeColors={bulletColorSelector({
          data: chartData.indexes,
          config: styleConfig,
          globalConfig,
        })}
        /* AXIS */
        axisPosition={styleConfig.AxisPosition}
        titlePosition={styleConfig.LabelPositionControl}
        titleOffsetX={
          styleConfig.LayoutControl === 'horizontal' ? (
            styleConfig.LabelPositionControl === 'after' ? 30 : -30
          ) : 0
        }
        titleOffsetY={
          styleConfig.LayoutControl === 'vertical' ? (
            styleConfig.LabelPositionControl === 'after' ? -190 : -15
          ) : 0
        }
        /* TOOLTIP / INTERACTIVE */
        isInteractive={styleConfig.InteractiveControl}
        tooltip={createTooltip}
        animate={styleConfig.InteractiveControl ? !!styleConfig.Animate : false}
        motionConfig={styleConfig.InteractiveControl ? (styleConfig.MotionConfig || 'default') : 'default'}
        /* THEME */
        theme={{
          labels: {
            text: {
              fontSize: `${styleConfig.LabelsFontSizeControl.value}px`,
              fontFamily: `'${globalConfig?.useGlobalFont ? globalConfig.fontLabel : styleConfig.LabelsFontFamilyControl.value}', Arial`,
              transform: `translate(${styleConfig.LabelTranslateX}px, ${styleConfig.LabelTranslateY}px) rotate(${styleConfig.LabelRotationControl}deg)`,
              transformOrigin: 'center center',
              transformBox: 'fill-box',
              fill: styleConfig.LabelColorControl,
            },
          },
          axis: {
            ticks: {
              text: {
                fontFamily: `'${globalConfig?.useGlobalFont ? globalConfig.fontAxis : styleConfig.AxisGlobal.fontFamily}', Arial`,
                fontSize: styleConfig.AxisGlobal.fontSize,
                transform: `translate(${styleConfig.AxisTranslateX}px, ${styleConfig.AxisTranslateY}px) rotate(${styleConfig.AxisRotationControl}deg)`,
                transformOrigin: 'center center',
                transformBox: 'fill-box',
                fill: styleConfig.AxisGlobal.color,
              },
            },
          },
        }}
      />
    </KpiStatus>
  ) : <></>;
};

Bullet.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  styleConfig: PropTypes.objectOf(PropTypes.any).isRequired,
  globalConfig: PropTypes.objectOf(PropTypes.any),
};

export default Bullet;
